import { observer } from 'mobx-react'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router'
import GlobalState from '../../../../stores/GlobalState'
import './index.scss'
import { ReactComponent as ArrowDown } from '../../../../assets/arr-down.svg'
import useOnClickOutside from '../../../common/Select/useOnClickOutside'
import classNames from 'classnames'

const ThingsScroll = observer(({ blocks }: { blocks: any }) => {
  const selectContainerRef = useRef<any>(null)
  const { pathname } = useLocation()
  const [selectedTab, setTab] = useState(0)
  const [showDropdown, setShow] = useState(false)
  const clickOutsideHandler = () => setShow(false)

  useOnClickOutside(selectContainerRef, clickOutsideHandler)

  const changeTab = (i: number) => {
    const top = document
      .querySelector(
        `#${blocks[i].linkblock
          .replaceAll("/for-you/", "")
          .replaceAll("/for-business/", "")}`
      )
      ?.getBoundingClientRect().top;
    if (top) {
      window.scrollTo({
        top: top - document.body.getBoundingClientRect().top - 60,
        behavior: 'smooth',
      })
    }
    setTab(i)
    setShow(false)
  }

  useEffect(() => {
    if (blocks && blocks.length) {
      const els: any = []
      blocks.forEach((b: any, i: number) => {
        const el = document.querySelector(
          `#${b.linkblock
            .replaceAll("/for-you/", "")
            .replaceAll("/for-business/", "")}`
        );
        if (el) {
          els.push({
            top:
              el.getBoundingClientRect().top -
              document.body.getBoundingClientRect().top -
              61,
            bottom: el.getBoundingClientRect().bottom - 120,
          })
        }
      })

      window.addEventListener('scroll', () => {
        els?.forEach((e: any, i: number) => {
          if (window.scrollY >= e.top && window.scrollY <= e.bottom) {
            setTab(i)
          }
        })
      })
    }
  }, [blocks])

  useEffect(() => {
    setTimeout(() => {
      const scrollBlock = document.querySelector(
        '.things-scroll .select-container',
      )
      if (!scrollBlock) return

      const top = scrollBlock?.getBoundingClientRect().top
      if (!top) return
      window.addEventListener('scroll', () => {
        if (window.scrollY >= top) {
          scrollBlock
            .querySelector('.selected-text')
            ?.classList.add('scroll-block')
        } else {
          scrollBlock
            .querySelector('.selected-text')
            ?.classList.remove('scroll-block')
        }
      })
    }, 1000)
  }, [])
  return (
    <section className="things-scroll">
      <div className="select-container" ref={selectContainerRef}>
        <div
          className={showDropdown ? 'selected-text active' : 'selected-text'}
          onClick={() => setShow(!showDropdown)}
        >
          <span>
            <img src={blocks[selectedTab].info.catIcon} />
            {blocks[selectedTab].info.cat}
          </span>
          <div className={classNames('select-icon', showDropdown && 'show-drop')}>
            {' '}
            <ArrowDown />
          </div>
        </div>
        <ul
          className={
            showDropdown
              ? 'select-options show-dropdown-options'
              : 'select-options hide-dropdown-options'
          }
        >
          {blocks.map((b: any, i: number) => {
            if (i == selectedTab) return <></>

            return (
              <li
                className="select-option"
                onClick={() => changeTab(i)}
                key={i}
              >
                <img src={b.info.catIcon} />
                {b.info.cat}
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
})

export default ThingsScroll
